import { selector } from 'recoil';

import {
  customerConsortiumChannelsSelectedState,
  customerConsortiumItemSelectedState,
  customerConsortiumPlanSelectedState,
  customerConsortiumRadioSelectedState,
  customerConsortiumSectionStatusState,
} from './atom';
import { CustomerSelection } from './types';

export const updateCustomerSectionStatus = selector({
  key: 'updateCustomerSectionStatus',
  get: ({ get }) => get(customerConsortiumSectionStatusState),
  set: ({ set }, status) => set(customerConsortiumSectionStatusState, status),
});

export const updateCustomerItemSelected = selector({
  key: 'updateCustomerItemSelected',
  set: ({ set, get }, customer) => {
    const currentCustomer = get(customerConsortiumItemSelectedState).current;
    const data = { current: customer, previous: currentCustomer } as CustomerSelection;
    set(customerConsortiumItemSelectedState, data);
  },
  get: ({ get }) => {
    const item = get(customerConsortiumItemSelectedState);
    return item;
  },
});

export const hasCustomerItemSelected = selector({
  key: 'hasCustomerItemSelected',
  get: ({ get }) => {
    const currentCustomer = get(customerConsortiumItemSelectedState).current;
    const hasCustomerSelected = !!(currentCustomer && Object.keys(currentCustomer)?.length > 0);
    return hasCustomerSelected;
  },
});

export const customerConsortiumPlanIsSelectedSelector = selector({
  key: 'customerConsortiumPlanIsSelectedSelector',
  get: ({ get }) => {
    const currentPlan = get(customerConsortiumPlanSelectedState);
    return !!currentPlan;
  },
});

export const updateCustomerConsortiumPlanSelected = selector({
  key: 'updateCustomerConsortiumPlanSelected',
  get: ({ get }) => get(customerConsortiumPlanSelectedState),
  set: ({ set }, plan) => set(customerConsortiumPlanSelectedState, plan),
});

export const updateCustomerConsortiumRadioSelectedOptionSelector = selector({
  key: 'updateCustomerConsortiumRadioSelectedOptionSelector',
  get: ({ get }) => get(customerConsortiumRadioSelectedState),
  set: ({ set }, option) => set(customerConsortiumRadioSelectedState, option),
});

export const updateCustomerConsortiumChannelsSelectedSelector = selector({
  key: 'updateCustomerConsortiumChannelsSelectedSelector',
  get: ({ get }) => get(customerConsortiumChannelsSelectedState),
  set: ({ set }, channels) => set(customerConsortiumChannelsSelectedState, channels),
});

export const hasCustomerConsortiumChannelsSelectedSelector = selector({
  key: 'hasCustomerConsortiumChannelsSelectedSelector',
  get: ({ get }) => get(customerConsortiumChannelsSelectedState).length > 0,
});
